import React, { useState } from 'react'
// import ReactDOM from 'react-dom'
import { compose } from 'recompose'
// import Script from 'react-load-script'
import { Button, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
import _entries from 'lodash/entries'
// import moment from 'moment'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
// import TransferModal from './TransferModal'
import { Block } from '../styles'
// import { inject, observer } from 'mobx-react'
const PayatallCash = compose(
  // inject('i18n'),
  injectIntl,
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
  // observer
)(({ intl, registration, payRegistration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted, bankAccountInfo }) => {
  const totalAmount = discounted + itemsDiscounted
  // const fee = Math.round(gatewayRate * discounted * 100) / 100
  const [paymentLoading, setPaymentLoading] = useState(false)

  const handleCheckout = async () => {
    setPaymentLoading(true)
    try {
      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method: 'payatall_cash',
            data: {
              payatall: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      const formData = _get(data, 'payRegistration.record.data.payatall.formData')
      console.log({ formData })
      const form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('action', formData.payNowUrl)
      // form.setAttribute('target', 'PayAtAll')
      _entries(formData).forEach(([key, value]) => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = value
        form.appendChild(input)
      })
      document.body.appendChild(form)
      form.submit()
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      setPaymentLoading(false)
    }
  }

  return <Block>
    <div className="title">
      <FormattedMessage id="paymentMethod.payatall_cash" />
    </div>
    <div>
      {systemFee
        ? <React.Fragment>
          <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted - totalSystemFee)
          }} />
          <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(totalSystemFee)
          }} />
        </React.Fragment>
        : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(discounted)
        }} />
      }
      {/* <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
        amount: intl.formatNumber(fee)
      }} /> */}
      {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
        amount: intl.formatNumber(itemsDiscounted)
      }} />}
    </div>
    <Button
      type="primary"
      onClick={() => handleCheckout()}
      loading={paymentLoading}
      className="paymentButton"
    >
      <FormattedMessage id="app.payBaht" values={{
        amount: intl.formatNumber(totalAmount)
      }} />
    </Button>
  </Block>
})

export default PayatallCash



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/PayatallCash/PayatallCash.js